"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTooltipHeaderFormatterSelector = void 0;
var settings_1 = require("../../specs/settings");
var create_selector_1 = require("../create_selector");
var get_settings_specs_1 = require("./get_settings_specs");
exports.getTooltipHeaderFormatterSelector = (0, create_selector_1.createCustomCachedSelector)([get_settings_specs_1.getSettingsSpecSelector], getTooltipHeaderFormatter);
function getTooltipHeaderFormatter(settings) {
    var tooltip = settings.tooltip;
    if (tooltip && (0, settings_1.isTooltipProps)(tooltip)) {
        return tooltip.headerFormatter;
    }
}
//# sourceMappingURL=get_tooltip_header_formatter.js.map